<!-- static content data from lang: question -->
<template>
  <div>
    <div class="h-100" v-loading="loading">
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.AddheaderTitle}}</h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div class="col-md-12">
            <template v-for="(message) in alertMessages">
              <Alert :type = alertType dismissible  v-if="message" :key="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            </template>
            <template v-for="(message) in successMessages">
              <Alert :type = successType dismissible  v-if="message" :key="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            </template>
            <validation-observer v-slot="{handleSubmit}" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-md-12">
                        <base-input
                          alternative
                          :label="lang.label.name"
                          class="mb-3"
                          :rules="{required: true}"
                          name="group name"
                          prepend-icon="fas fa-users"
                          :placeholder="lang.label.name"
                          v-model="model.groupName"
                          labelClasses="form-control-label asterisk-mark"
                          autocomplete="off"
                        ></base-input>
                        <template v-for="(person,index) in personInfo">
                          <div :key="index">
                            <!--<div class="form-group pt-3">
                              <label for="person">{{lang.label.personNumber}} - {{(index+1)}}</label>&nbsp;&nbsp;
&lt;!&ndash;                              <a v-if="index == 0" title="clear" class="text-red fas fa-backspace" href="javascript:void(0)" @click="removePerson(index)"></a>&ndash;&gt;
&lt;!&ndash;                              <a v-if="index > 0"  title="remove" class="text-red fas fa-times-circle" href="javascript:void(0)" @click="removePerson(index)"></a>&ndash;&gt;
                            </div>-->
                            <div class="form-group">
                              <div class="col-lg-6 pl-0">
                                <base-input
                                  alternative
                                  :label="lang.label.personName"
                                  class="mb-3"
                                  :rules="{required: true}"
                                  :name="'person- '+(index+1)+'\'s name'"
                                  prepend-icon="fas fa-users"
                                  :placeholder="lang.label.personName"
                                  v-model="person.name"
                                  labelClasses="form-control-label asterisk-mark"
                                  autocomplete="off"
                                ></base-input>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="col-lg-6 pl-0">
                                <base-input
                                  :label="lang.label.relationship"
                                  :name="'person- '+(index+1)+'\'s relation type'"
                                  rules="required"
                                  labelClasses="form-control-label asterisk-mark"
                                >
                                  <el-select
                                    v-model="person.relation"
                                    autocomplete="off"
                                    :placeholder="lang.label.selectRelationType"
                                    filterable
                                  >
                                  <el-option
                                      v-for="(option,index) in sortedRelationTypes"
                                      :key="index"
                                      :label="option.Name"
                                      :value="option.ID"
                                    ></el-option>
                                  </el-select>
                                </base-input>
                              </div>
                            </div>
                            <div class="form-group" v-if="person.photo">
                              <base-input
                                :label="lang.label.changeLogo"
                                name="change photograph"
                                :rules="{required: true}"
                              >
                                <b-form-group class="mb-0">
                                  <b-form-radio-group
                                    :id="'radio-group'+index"
                                    v-model="changePhotos[index]"
                                    autocomplete="off"
                                    :options="options"
                                    :name="'radio-group'+index"
                                  ></b-form-radio-group>
                                </b-form-group>
                              </base-input>
                            </div>
                            <div class="form-group photo-upload">
                              <div class="row">
                                <div class="col-3" v-if="person.photo ? changePhotos[index] == 'Yes' : true">
                                  <base-input
                                    :name="'person- '+(index+1)+'\'s photo'"
                                    labelClasses="form-control-label asterisk-mark"
                                    :rules="$refs.extraPerson && $refs.extraPerson[index] ?($refs.extraPerson[index].dropzone.files.length ? '': {required: true}) : ''"
                                    :label="lang.label.uploadThePhoto">
                                    <vue-dropzone
                                      ref="extraPerson"
                                      id="extraPerson"
                                      :options="dropzoneOptions"
                                      class="textFile"
                                      v-model="person.photo"
                                      autocomplete="off"
                                      @vdropzone-file-added="filesAdded"
                                      @vdropzone-success="fileSuccess"
                                      @vdropzone-removed-file="filesRemoved"
                                    ></vue-dropzone>
                                  </base-input>
                                </div>
                                <div class="col-4 pt-4 pl-3">
                                  <img  v-if="!photosAdded[index] && person.photo" height="150px" :src="person.photo" alt="company logo">
                                </div>
                              </div>
                            </div>
                            <hr v-if="index != personInfo.length-1">
                          </div>
                        </template>
                        <div class="pt-4 pb-2">
                          <label for="otherPersons">{{lang.label.addPerson}}</label>
                          <span class="pl-3" title="add a person"><a @click="addPerson" href="javascript:void(0)"><i class="fas fa-user-plus"></i></a></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-right mb-3">
                  <base-button type="primary" :disabled="uploading" native-type="submit">{{lang.label.buttons.save}}</base-button>
                  <base-button
                    type="danger"
                    @click="!login.IsVisitor ? $router.push({name: 'visitorManagement'}) : $router.push({name: 'groupManagement'})"
                  >{{lang.label.buttons.cancel}}</base-button>
                </div>
              </form>
            </validation-observer>
          </div>
        </card>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import HtmlEditor from '@/components/Inputs/HtmlEditor'
import Alert from "@/components/BaseAlert.vue";
import { Select, Option } from "element-ui";
import {mapGetters} from "vuex";
export default {
  components: {
    RouteBreadCrumb,HtmlEditor,
    [Select.name]: Select,
    [Option.name]: Option,
    Alert,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      lang: this.$lang.group_management,
      currentIndex: 0,
      groupID: '',
      alertType: 'danger',
      successType: 'success',
      alertMessages: [],
      successMessages: [],
      fileObject: [],
      uploading: false,
      loading: false,
      relationTypes: [
      {ID: 0, Name: 'Other'},
      {ID: 1, Name: 'Son'},
      {ID: 2, Name: 'Daughter'},
      {ID: 3, Name: 'Friend'},
      {ID: 4, Name: 'Father'},
      {ID: 5, Name: 'Pupil'},
      {ID: 6, Name: 'Tourist'},
      {ID: 7, Name: 'Mother'},
      {ID: 8, Name: 'Colleague'},
      {ID: 9, Name: 'Spouse'},
      {ID: 10, Name: 'Supplier'},
      ],
      selects: {
            simple: "Select"
      },
      changePhotos: [],
      personInfo: [{name: '', relation: '', photo: ''}],
      numberOfPersons: 1,
      photosAdded: [],
      options: [
            { text: "Yes", value: "Yes" },
            { text: "No", value: "No" }
        ],
      dropzoneOptions: {
            url: "https://httpbin.org/post",
            thumbnailWidth: 200,
            addRemoveLinks: true,
            uploadMultiple: false,
            maxFilesize: 10,
            maxFiles: 1,
            acceptedFiles: ".jpg, .jpeg, .png",
            dictDefaultMessage:
                "<div class='upload-docs'><p>Drop file here <br/>or <br/>click to upload</p></div>"
        },
      model: {
        groupName:''
      },
    };
  },
  computed:{
        ...mapGetters({
            addGroups: "addGroups",
            login: "login",
            userType: "type",
            visitorId: "visitorId",
            formID: "formID",
        }),
        sortedRelationTypes(){
            return [...this.relationTypes].sort((a,b)=>{
                const an = (a.Name || '').toString().toLowerCase();
                const bn = (b.Name || '').toString().toLowerCase();
                if(an < bn) return -1;
                if(an > bn) return 1;
                return 0;
            });
        }
    },
    created(){
        if(this.addGroups){
            localStorage.setItem('addGroups', JSON.stringify(this.addGroups));
        } else {
            let option = localStorage.getItem('addGroups');
            if(option !== null) {
                let parsed = option;
                try { parsed = JSON.parse(option); } catch(e) {}
                this.$store.commit('setAddGroups', parsed === true || parsed === 'true');
            }
        }
        if((this.formID && this.addGroups) == false) {
            if(!(this.login && this.login.IsVisitor == true)){
                this.$router.push({ name: 'addGroupManagement' });
            }
        }
    },
  methods: {
    addMembers(index){
        let self = this;
        let formData = new FormData();
        formData.append('VisitorGroupsID', this.groupID);
        formData.append('Name', this.personInfo[index].name);
        formData.append('Photograph', this.$refs.extraPerson[index].dropzone.files[0]);
        formData.append('RelationshipType', this.personInfo[index].relation);
        this.$store.dispatch('addGroupMember', formData)
            .then(response => {
                 if (response.status == 200) {
                     if(this.personInfo.length-1 != index) {
                         this.addMembers(index+1);
                     }else {
                         this.successMessages.push(response.data.message);
                         if(this.addGroups &&  !this.login.IsVisitor) {
                             this.$router.push({name: "visitor", params: {id: self.formID}});
                         }else {
                             this.$router.push({ name: "groupManagement"});
                         }
                         setTimeout(function () {
                             self.successMessages = [];
                         }, 5000);
                         this.loading = false;
                     }
                 }else {
                     if(typeof response.data.message != 'object'){
                         this.alertMessages.push(response.data.message);
                         setTimeout(function () {
                             self.alertMessages = [];
                         }, 5000);
                     }else{
                         var array = new Array();
                         for (let key of Object.keys(response.data.message)) {
                             let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                             array.push(obj)
                         }
                         this.alertMessages.push(array.join(', '));
                         setTimeout(function () {
                             self.alertMessages = [];
                         }, 5000);
                     }
                     this.loading = false;
                 }
            }).catch(reason => {
                this.loading = false;
                console.log('reason', reason);
        })
    },
    addPerson() {
      this.personInfo.push({name: '', relation: '', photo: ''});
    },
    removePerson(index) {
        this.removeFile(index);
        // console.log(this.$refs.extraPerson);
        this.personInfo = this.personInfo.filter((obj, ind)=>{
            return ind != index;
        });
    },
    removeFile(index) {
        this.fileObject = [];
        let totalFiles = this.$refs.extraPerson;
        totalFiles = totalFiles.filter((object, id)=> {return id != index});
        for(let i= 0; i< totalFiles.length; i++) {
            this.fileObject.push({file: totalFiles[i].dropzone.files[0], url: totalFiles[i].dropzone.files[0].dataURL})
        }
        totalFiles.forEach((object) => { object.removeAllFiles() });
        this.manuallyAddFiles();
    },
    manuallyAddFiles() {
        for(let i=0; i < this.fileObject.length; i++) {
              console.log("file", this.fileObject[i].file);
              console.log("url", this.fileObject[i].url);
             this.$refs.extraPerson[i].manuallyAddFile(this.fileObject[i].file, this.fileObject[i].url);
        }
    },
    filesAdded(file){
          // this.$refs.extraPerson.removeFile(file)
          this.observeFiles();
          this.uploading = true;
    },
    fileSuccess(file) {
          this.uploading = false;
    },
    observeFiles(){
          this.photosAdded = new Array(this.numberOfPersons);
          this.$refs.extraPerson.forEach((object, index)=>{
              this.photosAdded[index] = object.dropzone.files.length ? true : false;
          });
      },
    filesRemoved(file,error){
          this.observeFiles();
          this.uploading = false;
      },
    onSubmit() {
        this.loading = true;
         let data = {
               "Name": this.model.groupName,
               "VisitorID":  this.login.IsVisitor ? this.login.ID : this.visitorId
         };
         this.$store.dispatch('addVisitorGroup', data)
                    .then(response => {
                     if (response.status == 200) {
                         this.groupID = response.data.ID;
                         this.addMembers(0);
                     }else{
                         if(typeof response.data.message != 'object'){
                             this.alertMessages.push(response.data.message);
                         }else{
                             let array = new Array();
                             for (let key of Object.keys(response.data.message)) {
                                 let obj = response.data.message[key][0].includes('field') ? (key + "- " + response.data.message[key][0]) : response.data.message[key];
                                 array.push(obj);
                             }
                             this.loading = false;
                             this.alertMessages.push(array.join(', '))
                         }
                      }
                    }).catch(error => {

                        this.loading = false;
                    })
    },
  },
    destroyed() {
        this.$store.commit('setAddGroups', null);
        localStorage.removeItem('addGroups');
    }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
</style>
